namespace Areas.Maintenance {
    "use strict";

    export function closeRecord() {
        const dataGrid = $('#RequestGrid').dxDataGrid('instance');
        const rowInfo = dataGrid.getSelectedRowsData();
        const keyId = dataGrid.getSelectedRowKeys()[0];

        if (keyId == null) {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        } else {
            const url = `/Maintenance/RequestAccess/Close/${keyId}`;
            sendRequest(url, JSON.stringify(rowInfo), "PUT", () => { refreshGrid('RequestGrid'); });
        }
        //JSON.stringify(rowInfo)
    }

    export function voidRecord() {
        const verifyVoid = window.confirm("Are you sure you would like to VOID this record?");

        if (verifyVoid) {
            const dataGrid = $('#RequestGrid').dxDataGrid('instance');
            const keyId = dataGrid.getSelectedRowKeys()[0];

            if (keyId == null) {
                DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
            } else {
                const url = `/Maintenance/RequestAccess/Delete/${keyId}`;
                sendRequest(url, "", "DELETE", () => { refreshGrid('RequestGrid');  });
            }
        }
    }

    function refreshData(dataGrid: DevExpress.ui.dxDataGrid) {
        dataGrid.refresh();
        dataGrid.deselectRows(dataGrid.getSelectedRowKeys());
    }

  

}

